import { callBffApi } from "../../../common/services/axios";

export type TeamGithubOrganisationsResponse = {
  organisations: string[];
};

export const fetchTeamGithubOrganisationsFromBff = (teamId: string) =>
  callBffApi<TeamGithubOrganisationsResponse>(
    "get",
    `/teams/${encodeURIComponent(teamId)}/github-organisations`,
  );

/**
 * GITS GitHub org names from the BFF (`GET /bff/teams/:teamId/github-organisations`).
 * The BFF reads DI `{ "organizations": string[] }` and always responds with `{ organisations }` (UK key).
 */
export async function resolveGitsGithubOrganisations(teamId: string): Promise<string[]> {
  if (!teamId) {
    return [];
  }
  try {
    const { organisations } = await fetchTeamGithubOrganisationsFromBff(teamId);
    return (organisations ?? []).map((s) => String(s).trim()).filter((s) => s.length > 0);
  }
  catch {
    return [];
  }
}
